import styled from "styled-components"

const Body = styled.div`
  font-size: 1.25em;
  line-height: 1.5;
  color: #2a426b;
`

export default Body
